// extracted by mini-css-extract-plugin
export default {"FooterDesktop":"FooterDesktop_FooterDesktop__4G4cw","FooterDesktopLink":"FooterDesktop_FooterDesktopLink__WLlIp"};